/**
 * @name graph-hub
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjciIHI9IjQiIC8+CiAgPGNpcmNsZSBjeD0iNCIgY3k9IjE5IiByPSIyIiAvPgogIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTkiIHI9IjIiIC8+CiAgPGNpcmNsZSBjeD0iMjAiIGN5PSIxOSIgcj0iMiIgLz4KICA8cGF0aCBkPSJNOCA3YTQgNCAwIDAgMC00IDR2NiIgLz4KICA8cGF0aCBkPSJNMTIgMTF2NiIgLz4KICA8cGF0aCBkPSJNMTYgN2E0IDQgMCAwIDEgNCA0djYiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/graph-hub
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const GraphHub: string = `
<svg
  class="lucide lucide-graph-hub"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <circle cx="12" cy="7" r="4" />
  <circle cx="4" cy="19" r="2" />
  <circle cx="12" cy="19" r="2" />
  <circle cx="20" cy="19" r="2" />
  <path d="M8 7a4 4 0 0 0-4 4v6" />
  <path d="M12 11v6" />
  <path d="M16 7a4 4 0 0 1 4 4v6" />
</svg>
`;

export default GraphHub;
